import { useCallback } from 'react';
import { useApiPost } from '../../api/Api.hooks';
import { StudyParticipant } from '../../models/StudyParticipant';

export interface StudyParticipantEventNotificationDto {
  preferredNotificationTime: string;
}

export function useUpdateNotificationTime(studyParticipantId: number) {
  const path = `study-participants/${studyParticipantId}/notification-time`;
  const { data, isLoading, error, post } = useApiPost<StudyParticipant>(path);

  const updateNotificationTime = useCallback(
    (
      studyParticipantEventNotificationDto: StudyParticipantEventNotificationDto
    ) => {
      post(studyParticipantEventNotificationDto);
    },
    [post]
  );
  return {
    updatedNotificationTime: data,
    updatingNotificationTime: isLoading,
    updatingNotificationTimeError: error,
    updateNotificationTime
  };
}
